import * as React from 'react';
export const pacificwesternSvg = React.forwardRef(
  function pacificwesternSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#1B65A6',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'M1.73 21.62H14.3s0-2 1.7-2 1.7 2 1.7 2h12.57l-9.34-1.09 5.77-3.63-6.62 1.82 5.1-6.9-6.46 5.45 1.53-6.72-3.23 5.8L16 6.93l-1.02 9.44-3.23-5.81 1.53 6.72-6.45-5.45 5.1 6.9L5.3 16.9l5.77 3.63-9.34 1.1z',
        }),
      ),
    );
  },
);
pacificwesternSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var pacificwestern = {
  category: 'brand',
  colorable: false,
  name: 'pacificwestern',
  svg: pacificwesternSvg,
};
